import React from "react";
import { useSelector } from "react-redux";
import { Grid } from "@material-ui/core";

import FacilityActivity from "../../../components/Administration/FacilityActivity";
import { useStyles } from "./styles";

const FacilityActivityPage = () => {
  const classes = useStyles();
  const isAdmin = useSelector((state) => state?.user?.isAdmin);

  if (!isAdmin) return null;

  return (
    <div className={classes.root}>
      <Grid className={classes.contentContainer} item xs={12}>
        <FacilityActivity />
      </Grid>
    </div>
  );
};

export default FacilityActivityPage;
